export const ROLE_LABELS: Record<string, string> = {
  gerant: "Gérant / Admin",
  reception: "Réception",
  chef_atelier: "Chef d'atelier",
  mecanicien: "Mécanicien",
  caissier: "Caissier",
};

const P: Record<string, string[]> = {
  clients: ["gerant", "reception", "chef_atelier", "caissier"],
  clients_write: ["gerant", "reception"],
  agenda: ["gerant", "reception", "chef_atelier"],
  reception: ["gerant", "reception", "chef_atelier"],
  quotes: ["gerant", "reception", "chef_atelier"],
  orders: ["gerant", "reception", "chef_atelier"],
  orders_manage: ["gerant", "chef_atelier"],
  mechanic: ["gerant", "chef_atelier", "mecanicien"],
  catalog: ["gerant", "reception", "chef_atelier", "caissier"],
  catalog_write: ["gerant"],
  stock: ["gerant", "chef_atelier"],
  billing: ["gerant", "caissier", "reception"],
  billing_validate: ["gerant", "caissier"],
  dashboard: ["gerant", "caissier", "reception", "chef_atelier"],
  admin: ["gerant"],
};

export const can = (role: string | undefined, perm: string) => !!role && (P[perm] || []).includes(role);

export const da = (v: number | undefined | null) =>
  `${new Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(v || 0))} DA`;

export const km = (v: any) => (v ? `${new Intl.NumberFormat("fr-FR").format(v)} km` : "—");

export const fmtDate = (iso?: string, withTime = true) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("fr-FR", withTime ? { dateStyle: "short", timeStyle: "short" } : { dateStyle: "short" });
};

type Tone = "info" | "warn" | "ok" | "err" | "neutral" | "accent";
export const TONES: Record<Tone, string> = {
  info: "bg-sky-500/15 text-sky-300 border-sky-500/40 [.light_&]:text-sky-700",
  warn: "bg-amber-500/15 text-amber-300 border-amber-500/40 [.light_&]:text-amber-700",
  ok: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40 [.light_&]:text-emerald-700",
  err: "bg-red-500/15 text-red-300 border-red-500/40 [.light_&]:text-red-700",
  neutral: "bg-zinc-500/10 text-zinc-300 border-zinc-500/30 [.light_&]:text-zinc-600",
  accent: "bg-violet-500/15 text-violet-300 border-violet-500/40 [.light_&]:text-violet-700",
};

export const STATUS: Record<string, [string, Tone]> = {
  prevu: ["Prévu", "info"],
  arrive: ["Arrivé", "ok"],
  annule: ["Annulé", "neutral"],
  absent: ["Absent", "err"],
  presente: ["À l'atelier", "warn"],
  restitue: ["Restitué", "ok"],
  brouillon: ["Brouillon", "neutral"],
  envoye: ["Présenté", "info"],
  accepte: ["Accepté", "ok"],
  refuse: ["Refusé", "err"],
  remplace: ["Remplacé", "neutral"],
  a_faire: ["À faire", "info"],
  en_cours: ["En cours", "warn"],
  termine: ["Attente CQ", "accent"],
  qc_ok: ["CQ validé", "ok"],
  cloture: ["Clôturé", "ok"],
  validee: ["Validée", "ok"],
  impayee: ["Impayée", "err"],
  partielle: ["Partielle", "warn"],
  payee: ["Payée", "ok"],
  annulee: ["Annulée (avoir)", "neutral"],
  avoir: ["Avoir", "accent"],
};

export const PAY_METHODS: Record<string, string> = {
  especes: "Espèces",
  cheque: "Chèque",
  virement: "Virement",
  carte: "Carte (TPE)",
};

export const toLocalInput = (d: Date) => {
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};
